import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Heading,
  Image,
  Text,
  HStack,
  Tooltip,
  Icon,
  Progress
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import profileStyle from "./ProfileBasicDetails.module.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { calculateAge } from "../Action/calculateAge";
import { AiOutlineMail, AiOutlineWhatsApp } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import ProfileProgress from "./ProfileProgress";
import QRCode from "qrcode.react";
import apiConfig from "../../../apiConfig/apiConfig";
import { BenDataProps } from "../../../Helper/BenInterface";
import { FaHome } from "react-icons/fa";
import { getDocument } from "../../../http";
import { getImageBaseUrl } from "../../../Helper/env";
import { MdOutlineLocalHospital } from "react-icons/md";
import { FiDatabase } from "react-icons/fi";
import { TbAmbulance } from "react-icons/tb";
const frontEndURL = apiConfig.api.frontEndURL;

interface IndexCircleProps {
  value: number;
  icon: any;
  colorLabel: 'green' | 'orange' | 'red';
}

const IndexCircle: React.FC<IndexCircleProps> = ({ value, icon, colorLabel }) => {
  const colorStyles = {
    green: {
      main: '#38A169', // green.500
      light: '#ffffff'
    },
    orange: {
      main: '#DD6B20', // orange.400
      light: '#fdfdfd'
    },
    red: {
      main: '#E53E3E', // red.500
      light: '#fcfcfc'
    }
  };

  const colors = colorStyles[colorLabel];

  return (
    <Tooltip label={`${value}%`} hasArrow>
      <Box
        borderRadius="full"
        boxSize="35px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        overflow="hidden"
        position="relative"
        // This creates the "Pie" fill effect
        background={`conic-gradient(${colors.main} ${value}%, ${colors.light} 0)`}
        border="2px solid"
        borderColor={colors.main}
      >
        <Icon
          as={icon}
          boxSize="18px"
          color="black"
          zIndex={1}
        />
      </Box>
    </Tooltip>
  );
};

const ProfileBasicDetail: React.FC<{
  data: BenDataProps;
  downloadProfilePdf: () => void;
  isLoading: Boolean;
}> = ({ data, downloadProfilePdf, isLoading }) => {
  // const subscriber = useSelector((state: any) => state.subscriber);
  const userData: any = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const [image,setImage]=useState("")

  const [completionPercentage, setCompletionPercentage] = useState(0);
  const handleEdit = (benId: string) => {
    navigate(`/addBenFullDetails/${benId}`);
    sessionStorage.setItem("stepNumber", "1"); //here .ts through error if i send as number
  };

  const getColorLabel = (val: number): 'green' | 'orange' | 'red' =>
    val >= 60 ? 'green' : val >= 40 ? 'orange' : 'red';

  useEffect(() => {
    const check = data?.progress || 0;
    const totalPercentage = Math.round((check / 6) * 100);
    setCompletionPercentage(totalPercentage);


     const fetchphoto=async()=>{
          try{
            const response = await getDocument(data?.personalInfo?.image);
           const blob = new Blob([response.data], { type: response.headers["content-type"] });
           const  url = URL.createObjectURL(blob);
         setImage(url)
          }catch(err){
            console.log(err)
          }
    
         }
         if(data?.personalInfo?.image){
          fetchphoto()
         }
         
  }, [completionPercentage, data]);

const ambulanceIndex = data.indices?.ambulance_Index ?? 0;
const dataIndex = data.indices?.data_Index ?? 0;
const hospitalIndex = data.indices?.hospital_Index ?? 0;
const overallIndex = data.indices?.overall_Index ?? 0;

  return (
    <Box className={profileStyle.ben_PersonalDetails}>
      <Box className={profileStyle.personalDetails_Top}>
        <Center>
          <Box
            mt={"1rem"}
            padding={".2rem"}
            borderRadius={"1rem"}
            backgroundColor={"white"}
            onClick={() => navigate("/dashboard")}
          >
            <Text color={"#008470"} fontSize={"2rem"}>
              <FaHome />
            </Text>
          </Box>
        </Center>
        <Box>
          <Heading textAlign={"center"} size="md" mt={"4"} mb={"6"}>
            Your Pococare Emergency Ready Kit (PERK)
          </Heading>
        </Box>
        <Box className={profileStyle.personDetails_Child}>
          <Box className={profileStyle.personDetails_left}>
            <Box className={profileStyle.personDetails_right_img}>
              {data?.personalInfo?.image ? (
                data?.personalInfo?.image.split(":").length !== 2 ? (
                  <Image
                    width={"100%"}
                    src={`${apiConfig.api1.baseURL}/beneficiariesProfilePhotos/${data?.personalInfo?.image}`}
                    alt="Invalid"
                  />
                ) : (
                  <Image
                    width={"100%"}
                    src={image}
                    alt="Invalid"
                    crossOrigin="anonymous"
                  />
                )
              ) : (
                <Text className={profileStyle.benName_center}>
                  {(data.personalInfo?.fullName?.[0] || "").toUpperCase()}
                </Text>
              )}

              <Box className={profileStyle.circleProgress}>
                <ProfileProgress
                  percentage={completionPercentage}
                  strokeWidth={3}
                  circleSize={"115px"}
                />
              </Box>
            </Box>
            <Box className={profileStyle.nameContainer}>
              <Text className={profileStyle.benName} fontSize={"22px"}>
                {data.personalInfo.fullName || ""}
              </Text>
              <Text className={profileStyle.relationToBen} fontSize={"18px"}>
                {data?.personalInfo?.relationshipToSubscriber}
              </Text>
            </Box>
          </Box>
          <Box className={profileStyle.personDetails_middle}>
            <HStack>
              <IndexCircle value={ambulanceIndex} icon={TbAmbulance} colorLabel={getColorLabel(ambulanceIndex)} />
              <Text fontSize="xs" fontWeight="600">Ambulance Index : {ambulanceIndex}%</Text>
            </HStack>
            <HStack>
              <IndexCircle value={dataIndex} icon={FiDatabase} colorLabel={getColorLabel(dataIndex)} />
              <Text fontSize="xs" fontWeight="600">Information Index : {dataIndex}%</Text>
            </HStack>
            <HStack>
              <IndexCircle value={hospitalIndex} icon={MdOutlineLocalHospital} colorLabel={getColorLabel(hospitalIndex)} />
              <Text fontSize="xs" fontWeight="600">Hospital Index : {hospitalIndex}%</Text>
            </HStack>
            <Box w="100%" mt={2}>
              <Text fontSize="xs" fontWeight="600" mb={1}>Overall Index</Text>
              <HStack w="100%" spacing={3} alignItems="center">
                <Progress
                  value={overallIndex}
                  size="xs"
                  flex="1"
                  borderRadius="md"
                  colorScheme={getColorLabel(overallIndex)}
                />
                <Text color="#6F6F6F" fontSize="xs" minW="40px" textAlign="right">
                  {overallIndex}%
                </Text>
              </HStack>
            </Box>
          </Box>
          <Box className={profileStyle.personDetails_right}>
            <Box className={profileStyle.personalDetails_RightDet}>
              <Box textAlign={"center"}>
                <Flex justifyContent={"space-around"}>
                  <QRCode
                    value={`${frontEndURL || "https://www.pococare.com"
                      }/trigger-emergency/${data?._id}`}
                    id="canvas"
                    size={120}
                    level={"H"}
                    includeMargin={true}
                    imageSettings={{
                      src: "/Images/transparentLogo.png",
                      x: 30,
                      y: 30,
                      height: 30,
                      width: 30,
                      excavate: true,
                    }}
                  />
                </Flex>
                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  Scan me during an emergency
                </p>
                <p
                  style={{
                    fontSize: "15px",
                    color: "blue",
                    fontWeight: "bold",
                    marginTop: "10px",
                    cursor: "pointer",
                  }}
                >
                  <a
                    href={`${getImageBaseUrl()}/azure/api/v1/signedUrl/get-public-document/others/Pococare_QR_Code_Manual.pdf`}
                    rel="noreferrer"
                    target="_blank"
                  >
                    Click here for the QR code manual
                  </a>
                </p>
                <Button
                  loadingText="Downloading"
                  isLoading={isLoading as boolean}
                  onClick={() => {
                    downloadProfilePdf();
                  }}
                >
                  Click here to download profile
                </Button>
              </Box>
            </Box>
          </Box>
          {/* //child */}
          <Box className={profileStyle.topColor}></Box>
        </Box>
        {/* <Box className={profileStyle.personalDetails_ChildMobile}>
                    <Box>
                        hhhhhhhhhhhhhhhhhhhhhhhhhhhhhh
                        <Flex justifyContent={"space-around"}>
                            <QRCode
                                value={`${frontEndURL}/trigger-emergency/${data?._id}`}
                                id="canvas"
                                size={120}
                                level={"H"}
                                includeMargin={true}
                                imageSettings={{
                                    // title: "avc",
                                    src: "/Images/transparentLogo.png",
                                    x: 30,
                                    y: 30,
                                    height: 30,
                                    width: 30,
                                    excavate: true,
                                }}
                            />
                        </Flex>
                        <p style={{ fontWeight: "bold", textAlign: "center" }}>
                            Scan me during an emergency
                        </p>
                        <p
                            style={{
                                fontSize: "15px",
                                color: "blue",
                                fontWeight: "bold",
                                marginTop: "10px",
                                cursor: "pointer",
                                textAlign: "center"
                            }}
                        >
                            <a
                                href="https://csg1003200234760c51.blob.core.windows.net/poco-prod/Pococare_QR_Code_Manual.pdf"
                                rel="noreferrer"
                                target="_blank"
                            >
                                Click here for the QR code manual
                            </a>
                        </p>
                    </Box>
                    <Box className={profileStyle.nameContainer}>
                        <Text className={profileStyle.benName} fontSize={"18px"} textAlign={"center"}>{data.personalInfo.fullName} ({data.personalInfo.relationshipToSubscriber}) {completionPercentage} %</Text>
                    </Box>
                </Box> */}
        <Divider borderWidth={"2px"} marginTop={"15px"} />
      </Box>
      <Box className={profileStyle.personalDetails_Bottom}>
        <Flex
          onClick={() => handleEdit(data._id)}
          flexDirection={"row-reverse"}
          mr={"8"}
          display={userData.userRole === "BENEFICIARY" ? "none" : "flex"}
        cursor={"pointer"}
        >
          <HiOutlinePencilSquare color={"#008470"} fontSize={"23px"} />
        </Flex>
        <Box className={profileStyle.profileDetails_Bot_child}>
          <Box className={profileStyle.profileDetails_Bot_left}>
            <Box>
              <Text className={profileStyle.subTitle}>Basic Info</Text>
              <Flex align={"center"} gap={"13px"} marginTop={"10px"}>
                <AiOutlineMail
                  fontSize="20px"
                  className={profileStyle.icon_Remove}
                />
                <Text className={profileStyle.relationToBen} fontSize={"18px"}>
                  {data.personalInfo.email || "Update now!"}
                </Text>
              </Flex>
            </Box>
          </Box>

          <Box className={profileStyle.profileDetails_Bot_right}>
            <Box className={profileStyle.contactDetails_Right_det}>
              <Flex align={"center"} gap={"10px"}>
                <BsTelephone
                  fontSize="20px"
                  className={profileStyle.icon_Remove}
                />

                <Text className={profileStyle.contact_Number}>
                  {data?.personalInfo?.mobile?.number || "Update now!"}
                </Text>
              </Flex>
              <Box className={""}>
                <Flex align={"center"} gap={"10px"}>
                  <AiOutlineWhatsApp
                    fontSize="20px"
                    className={profileStyle.icon_Remove}
                  />
                  <Text className={profileStyle.contact_Number}>
                    {data?.personalInfo?.whatsappMobile?.number ||
                      "Update now!"}
                  </Text>
                </Flex>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className={profileStyle.pendingDetails}>
          <Box>
            <Text className={profileStyle.pendingDetail_Title}>Gender</Text>
            <Text className={profileStyle.penDetails_det}>
              {data.personalInfo.gender || "Update now!"}
            </Text>
          </Box>
          <Box>
            <Text className={profileStyle.pendingDetail_Title}>
              {"Age"} <br></br>
            </Text>
            <Text className={profileStyle.penDetails_det}>
              {data?.personalInfo?.dateOfBirth
                ? calculateAge(data?.personalInfo?.dateOfBirth)
                : "Update now!"}
            </Text>
          </Box>
          {/* in feature need to redesign the data base if needed the employmentStatus field need to use this one */}
          <Box>
            {/* <Text className={profileStyle.pendingDetail_Title}>
              Employment Status
            </Text>
            <Text className={profileStyle.penDetails_det}>
              {employmentStatus || "---"}
            </Text> */}
          </Box>
          <Box></Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileBasicDetail;
